import { CloseOutlined } from '@material-ui/icons'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from 'core/components/Core'
import Typography from 'core/components/Typography'
import { ModalButtonLeft, ModalButtonRight } from './style'

function Modal(props) {
  const {
    children,
    disabled,
    loading,
    onConfirm,
    onCancel,
    onAbort,
    open,
    textCancel,
    textConfirm,
    PropsConfirm,
    PropsCancel,
    PropsContent,
    title,
    maxWidth,
    fullWidth,
    ...other
  } = props

  const hasActions = Boolean(textCancel || textConfirm)

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      onAbort={onAbort}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      {...other}
      data-testid="modal"
    >
      {title && (
        <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h5" style={{ flex: 1 }}>
            {title}
          </Typography>
          {onAbort && (
            <IconButton onClick={onAbort} aria-label={textCancel}>
              <CloseOutlined />
            </IconButton>
          )}
        </DialogTitle>
      )}
      <DialogContent dividers {...PropsContent}>
        {children}
      </DialogContent>
      {hasActions && (
        <DialogActions style={{ justifyContent: 'center' }}>
          {textCancel && (
            <ModalButtonLeft data-testid="on-cancel-button" onClick={onCancel} {...PropsCancel}>
              {textCancel}
            </ModalButtonLeft>
          )}
          {textConfirm && (
            <ModalButtonRight
              data-testid="on-confirm-button"
              disabled={disabled || !!loading}
              onClick={onConfirm}
              startIcon={
                loading ? (
                  <CircularProgress data-testid="on-confirm-loading" color="inherit" size={16} />
                ) : null
              }
              {...PropsConfirm}
            >
              {textConfirm}
            </ModalButtonRight>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}

Modal.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onAbort: PropTypes.func,
  onConfirm: PropTypes.func,
  open: PropTypes.bool,
  textCancel: PropTypes.string,
  textConfirm: PropTypes.string,
  title: PropTypes.any,
  PropsCancel: PropTypes.any,
  PropsContent: PropTypes.any,
  PropsConfirm: PropTypes.any,
  maxWidth: PropTypes.string,
  fullWidth: PropTypes.bool,
  PaperComponent: PropTypes.elementType,
}

Modal.defaultProps = {
  children: null,
  disabled: false,
  loading: false,
  onConfirm: () => null,
  onAbort: undefined,
  open: false,
  textCancel: null,
  textConfirm: null,
  title: null,
  PropsCancel: {},
  PropsConfirm: {},
  PropsContent: {},
  maxWidth: 'sm',
  fullWidth: false,
  PaperComponent: undefined,
}

export default Modal
